import { render, staticRenderFns } from "./AccidentDialog.vue?vue&type=template&id=3169d62a&scoped=true"
import script from "./AccidentDialog.vue?vue&type=script&lang=js"
export * from "./AccidentDialog.vue?vue&type=script&lang=js"
import style0 from "./AccidentDialog.vue?vue&type=style&index=0&id=3169d62a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169d62a",
  null
  
)

export default component.exports